module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/steps/event-areas/assets/reception-478154050360cfe4585b8fb80fe8a8ad.png";